export default function donateSchema(values) {
  const errors = {};
  if (!values.amount) {
    errors.amount = 'Amount is required';
  } else if (values.amount < 1) {
    errors.amount = 'Invalid Amount';
  }

  if (!values.name) {
    errors.name = 'Full Name is required';
  } else if (values.name.length < 2) {
    errors.name = 'Full Name is too short, at least 3 characters';
  }

  if (!values.email) {
    errors.email = 'Email is required';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Email Address is invalid';
  }

  if (
    values.phone &&
    !/^[+]?[(]?[0-9]{3}[)]?[-\s]?[0-9]{3}[-\s]?[0-9]{3,9}$/im.test(values.phone)
  ) {
    errors.phone = 'Phone Number is invalid';
  }

  if (!values.payment_method) {
    errors.payment_method = 'Payment is required';
  } else if (values.payment_method.match(/paypal|card|stripe|google/i) === -1) {
    errors.payment_method = 'Invalid payment method';
  }

  if (values.duration && values.duration.match(/O|M|Q|Y/) === -1) {
    errors.duration = 'Invalid Duration';
  }

  return errors;
}
